import React from "react";
import HeroDescription from "../heroDescription/index";

const PlanetDescription = ({
  planetData
}) => (
  <>
    <HeroDescription
      mainText={planetData.name} description={planetData.description}
    />
  </>
)

export default PlanetDescription